import Skeleton from '@srm/ui/skeleton';
import './SectionHub.scss';
import './SectionHubSkeleton.scss';

const SectionHubSkeleton = () => (
    <div className="rf-section-hub" role="status" aria-label="Загрузка раздела" aria-busy="true">
        <div aria-hidden>
            <Skeleton height={24} width="min(220px, 65%)" radius={8} />
            <Skeleton height={12} width="min(320px, 85%)" radius={6} mt={12} />
            <div className="rf-section-hub__grid">
                {[0, 1, 2, 3].map((group) => (
                    <div className="rf-section-hub-skeleton__group" key={group}>
                        <Skeleton height={14} width="48%" radius={6} />
                        {[72, 88, 60].map((width) => (
                            <Skeleton key={width} height={12} width={`${width}%`} radius={6} />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default SectionHubSkeleton;
